export default __webpack_public_path__ + "static/media/img-0763-slovenia-half-face.695b8855.png";